export default __webpack_public_path__ + "static/art-pt3-level-up-d6c58d0c57164ff6e6c76f49460f6f2b.jpg";